import { QueryParam } from '../'

export class SimpleQueryParam extends QueryParam<string> {
  public toString(): string {
    return encodeURI(`${this._key}=${this._value}`)
  }

  public add(value: string) {
    this._value = value
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/models/uri/query-param/simple-query-param/simple-query-param.ts